<template>
  <v-card class="elevation-12">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{$t('LoginPage.ResetForm.header')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field 
          id="email" 
          prepend-icon="email" 
          name="email" 
          :label="$t('LoginPage.Form.email')" 
          type="email" 
          v-model="email" 
          @keyup.enter="submit"
        >
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        text
        color="grey" 
        @click="$emit('cancel')" 
      >
        {{$t('Global.Action.cancel')}}
      </v-btn>
      <v-btn 
        color="primary" 
        :loading="loading" 
        @click="submit" 
        :disabled="!email"
      >
        {{$t('Global.Action.confirm')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import usersApi from '@/services/users'
export default {
  name: 'TheForgotPasswordForm',
  data: () => ({
    loading: false,
    email: ''
  }),
  methods: {
    async submit () {
      this.loading = true
      try {
        await usersApi.askForgotPassword(this.email)
        this.$emit('submitted')
      } catch (error) {
        this.loading = false
        this.$emit('error', this.$t('LoginPage.Error.askResetPassword'))
      }
    }
  }
}
</script>